import { useState, createContext, useMemo, lazy, useContext, useEffect } from "react";
import { useLocale, useSetLocale, useTranslate } from "react-admin";
import { useGetData } from "../hooks/useGetData";
import { LoaderApp } from "../components/layout/LoaderApp";
import { AppContext } from "./AppProvider";
import themeConfig from "../config";
import { lazyRetry } from '../utils/index';

const AlertModal = lazy(() => lazyRetry(() => import("../components/layout/AlertModal")));
const GlobalDataContext = createContext();

function GlobalDataProvider({ children }) {
  const { permissions, userBusiness, userBranch } = useContext(AppContext);
  const [listBusiness, setListBusiness] = useState([]);
  const [listBranches, setListBranches] = useState([]);
  const [listCategories, setListCategories] = useState([]);
  const [listTerminals, setListTerminals] = useState([]);
  const [listProcessor, setListProcessor] = useState([]);
  const [loading, setLoading] = useState(true)
  const [infoBusinessUser, setInfoBusinessUser] = useState(null);
  const [infoBranchUser, setInfoBranchUser] = useState(null);
  const [infoProcessorBusiness, setInfoProcessorBusiness] = useState(null);
  const { getAllData, modalErrorReq, setModalErrorReq } = useGetData(
    permissions,
    userBusiness
  );
  const setLocale = useSetLocale();
  const localLanguage = useLocale();
  const translate = useTranslate();
  const localStorageLanguage = window.localStorage.getItem("language");

  useMemo(() => {
    if (permissions !== "guest") {
      getAllData("business", setListBusiness);
      getAllData("branch", setListBranches);
      getAllData("category", setListCategories);
      getAllData("terminal", setListTerminals);
      getAllData("processor", setListProcessor);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useMemo(() => {
    if (
      permissions !== "Root" &&
      listBusiness.data &&
      listBranches.data &&
      listProcessor.data
    ) {
      let businessOfUser = listBusiness.data.find(
        (element) => element.id === parseInt(userBusiness)
      );
      let branchOfUser = listBranches.data.find(
        (element) => element.id === parseInt(userBranch)
      );
      let processorOfBusiness = listProcessor.data.filter(
        (element) => element.id === businessOfUser.processor_id
      );
      setInfoBusinessUser(businessOfUser);
      setInfoBranchUser(branchOfUser);
      setInfoProcessorBusiness(processorOfBusiness);

      console.log(branchOfUser)
      setLocale(
        branchOfUser ? branchOfUser.language : localStorageLanguage ?? "en"
      );
    } else if (permissions === "Root" && localLanguage === "es") {
      console.log("Entro 2")
      setLocale(localLanguage);
    } 

    if(listBranches.data && listBusiness.data && listProcessor.data){
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listBranches, listBusiness, listProcessor]);

  const value = {
    infoBusinessUser,
    setInfoBusinessUser,
    infoProcessorBusiness,
    listBranches,
    setListBranches,
    listCategories,
    setListCategories,
    listBusiness,
    setListBusiness,
    listProcessor,
    setListProcessor,
    infoBranchUser,
    listTerminals,
    setListTerminals,
  };

  console.log(loading)
  
  return (
    <GlobalDataContext.Provider value={value}>
      {/* {listBranches.data && listBusiness.data && listProcessor.data ? (
        children
      ) : (
        <>
          <LoaderApp/>
          {children}
        </>
      )} */}
      {
        loading && (<LoaderApp/>)
      }
      {children}
      
      <AlertModal
        openAlert={modalErrorReq}
        setOpenAlert={setModalErrorReq}
        titleModal={translate("ra.message.error_get_data")}
        handleConfirm={() => window.location.reload(true)}
        textConfirm={translate("ra.action.retry")}
        textCancel={translate("ra.action.close")}
      />
    </GlobalDataContext.Provider>
  );
}

export { GlobalDataContext, GlobalDataProvider };
